import PropTypes from "prop-types";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import {
  Card,
  CardBody,
  Col,
  Label,
  Row,
  Container
} from "reactstrap";

import LanguageDropdown from "components/Common/LanguageDropdown";
import { AiFillWindows } from "react-icons/ai";
import LoginHeader from '../../../pages/Authentication/components/header';
import LoginFooter from '../../../pages/Authentication/components/footer';

class CheckoutErrorForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <React.Fragment>
        <Container>
          <Row className="justify-content-center" >
            <Card className="overflow-hidden" style={{ border: '2px solid rgba(0, 0, 0, 0.08)', borderRadius: '8px' }}>
              <CardBody className="pt-1">
                <div style={{ textAlign: 'left', width: '100%' }}><LoginHeader /></div>
                <Row style={{ marginTop: "10px" }}>
                  <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Card className="overflow-hidden" style={{ marginTop: '5px' }}>
                      <div className="p-2" style={{ textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
                        <div>
                          <h4 style={{ color: "red" }}>
                            <i>
                              <img
                                src={this.props.errorIcon}
                                alt="errorIcon"
                                style={{ width: '75px', height: '75px', textAlign: 'center', justifyContent: 'center', fontSize: "8rem", color: "red", marginTop: '-4px', marginBottom: '10px' }}
                              />
                            </i>
                          </h4>
                          <h4 style={{ color: this.props.errorIsSuccess ? "black" : "red", whiteSpace: "pre-line" }}>{this.props.errorMessage}</h4>
                          <h5 style={{ color: "black" }}> <br></br><strong>{this.props.errorResult}</strong></h5>
                          <br></br><br></br>

                        </div>
                      </div>
                    </Card>
                  </Col>
                </Row>
              </CardBody>
              <div className="mt-5 text-center">
                <p><strong>© {new Date().getFullYear()} Morpara</strong></p>
              </div>
              <LoginFooter className="login-footer-container" text={this.props.t("login.footerText")} />
            </Card>
          </Row>
        </Container>

      </React.Fragment >
    );
  }
}

CheckoutErrorForm.propTypes = {
  onCloseClick: PropTypes.func,
  errorMessage: PropTypes.any,
  errorIcon: PropTypes.any,
  errorResult: PropTypes.any,
  errorIsSuccess: PropTypes.any,
  show: PropTypes.any,
  t: PropTypes.any,
};

export default (withTranslation()(CheckoutErrorForm));
